import {useState} from "react";
import {Button, Stack, TextField} from "@mui/material";
import Typography from "@mui/material/Typography";
import {hasFormChanged, zodSubmit} from "../../../utils/FormUtils";
import {z} from "zod";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import DisabledWrapper from "../../../components/DisabledWrapper";

const passwordRules = z.string()
    .min(8, "A jelszónak legalább 8 karakter hosszúnak kell lennie")
    .regex(/[a-z]/, "Legalább egy kisbetűt kell tartalmaznia")
    .regex(/[A-Z]/, "Legalább egy nagybetűt kell tartalmaznia")
    .regex(/[0-9]/, "Legalább egy számot kell tartalmaznia")
    .regex(/[^a-zA-Z0-9]/, "Legalább egy speciális karaktert kell tartalmaznia");

const schema = z.object({
    old_password: z.string().min(1, "A régi jelszó kötelező"),
    new_password: passwordRules,
    new_again: z.string().min(1, "Az új jelszó mégegyszer kötelező"),
}).refine(
    (data) => data.new_password === data.new_again,
    {
        message: "A két jelszó nem egyezik",
        path: ["new_again"], // error will appear under the second field
    }
)

const PasswordReset = ({handleSubmit}) => {
    const [errors, setErrors] = useState({});
    const [isDirty, setIsDirty] = useState(false);

    return <form
        onSubmit={e => setIsDirty(!zodSubmit(e, setErrors, handleSubmit, schema))}
        onChange={e => setIsDirty(hasFormChanged(e.currentTarget, {
            old_password: '',
            new_password: '',
            new_again: ''
        }))}
    >
        <Stack spacing={1} marginTop={2} marginBottom={2}>

            <Typography variant='caption' color='primary.main'>
                Régi jelszó*
            </Typography>
            <TextField
                error={!!errors.old_password}
                helperText={errors.old_password}
                name='old_password'
                variant='standard'
                type='password'
            />

            <Typography variant='caption' color='primary.main'>
                Új jelszó*
            </Typography>
            <TextField
                error={!!errors.new_password}
                helperText={errors.new_password}
                name='new_password'
                variant='standard'
                type='password'
            />

            <Typography variant='caption' color='primary.main'>
                Új jelszó mégegyszer*
            </Typography>
            <TextField
                error={!!errors.new_again}
                helperText={errors.new_again}
                name='new_again'
                variant='standard'
                type='password'
            />
            <DisabledWrapper disabledCause={[{
                disabled: !isDirty,
                message: 'Módosítsd a mezőket a mentéshez!'
            }]}>
                <Button
                    sx={{mt: 1}}
                    endIcon={<SaveRoundedIcon/>}
                    type="submit"
                    variant='contained'
                >
                    Jelszó módosítása
                </Button>
            </DisabledWrapper>
        </Stack>
    </form>
}

export default PasswordReset